import React from 'react';
import HomeScreen from './components/HomeScreen';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <HomeScreen />
    </div>
  );
}

export default App;